





























import { Component, Vue, Provide } from 'vue-property-decorator';
import MyNav from '@/components/nav/Index.vue'; // nav
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import {
  Button, Table, TableColumn, Message, Input, Tabs, TabPane,
} from 'element-ui';
import Read from '@/servers/modules/read/read';
// server
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Button,
        Tabs,
        TabPane,
        Input,
      },
    })
export default class extends Vue {
  @Mutation public setSkeletonDescribe:any;

  @Getter public skeleton: any;

  // 左侧菜单栏
  @Getter public scaleCommonIndex: any;

  // 当前选项
  private buttonActive: number = 0;

  // 切换选项展示
  private buttonData: any = [
    {
      name: '财富',
    },
    {
      name: '积分',
    },
    {
      name: '成绩',
    },
  ];

  // 表格样式
  private tableHeaderClassName() {
    return 'table-header';
  }

  private tableRowClassName(row:any) {
    let classStr = 'table-row';
    if (row.row.ranking < 4) {
      classStr += ' rank-three';
    }
    return classStr;
  }

  // 排行图片
  private tableDataImg:any={
    1: require('@/assets/images/ui-word/rank1.png'),
    2: require('@/assets/images/ui-word/rank2.png'),
    3: require('@/assets/images/ui-word/rank3.png'),
  };

  // 表格数据
  private tableData:any = [];


  private async created() {
    // this.setSkeletonDescribe(true);
    this.setSkeletonDescribe(false);
    this.title = '';// window.LS.get('vteData').course.courseTitle;
    this.getAllData(1);
  }

  private async barChangeType(type, typeName) {
    const data = {
      referScope: type,
      studentCourseId: window.LS.get('vteData').studentCourseId,
    };
    // 获取学习成绩
    const res = await Read.rankingList(data);
    console.log(res);
    Message(`切换${typeName}成功`);
    this.getAllData(1);
  }

  private async getAllData(type:number) {
    // 清空数据
    this.tableData = [];
    const data = {
      leaderboardType: type,
      pageNo: 20,
    };
    const res = await Read.queryLeaderboard(data);
    console.log(res);
    // 获取
    const studing = res.data.data;
    // let arr = [];
    // for(var i = 0 ; i < 20 ; i ++){
    //     arr.push(studing.leaderboardListVo[0]);
    // }
    this.tableData = studing.leaderboardListVo;
    // this.tableData = arr;
    this.data = studing.leaderboardMyDataVo;
    console.log(this.data);
  }

  private changeButton() {
    this.getAllData(Number(this.buttonActive) + 1);
  }

        private data:any = {};
}
